/**
 *
 * @author Matthew Rawson @ 15/01/2018 11:37
 *
 * Added a simple set timeout to delay the showing of this error. It is too flashy on the UI if it toggles visibility
 * quickly.
 *
 */
import React, {Component} from "react"
import styled from "styled-components"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography/Heading"
import ohsnap from "@irati/ui/images/oh_snap_2.svg"
import {DEFAULT_DEBOUNCE_TYPING_TO_URL} from "../../constants/search"

const Container = styled.div`
  margin: ${({theme}) => theme.spacing.four} 0 0 0;
`

class SearchTermValidationError extends Component {
  static propTypes = {}
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {
      active: false
    }

    this.timeout = null
  }

  UNSAFE_componentWillMount() {
    this.timeout = setTimeout(() => {
      this.setState({active: true})
    }, DEFAULT_DEBOUNCE_TYPING_TO_URL)
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render() {
    const idNamespace = id("search-term-validation-error", this.props)

    return (
      <div id={idNamespace}>
        {this.state.active && (
          <Container id={id("container", idNamespace)} className="center">
            <img id={id("img", idNamespace)} src={ohsnap} alt="search term validation error" />
            <H3 id={id("title", idNamespace)}>
              <FormattedMessage id="perks.search.validation.heading" />
            </H3>
            <p id={id("body", idNamespace)}>
              <FormattedMessage id="perks.search.validation.twoCharsRequired.message" />
            </p>
          </Container>
        )}
      </div>
    )
  }
}

export default SearchTermValidationError
